import { EditIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Container,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useQuery } from "react-query";
import { Link, useParams } from "react-router-dom";
import { getAdminReadingOrder } from "../../../services/adminApi";
import Spinner from "../../../shared/components/Spinner";
import ReadingOrderHeader from "../../reading/components/ReadingOrderHeader";
import ReadingOrderComicsForm from "../components/ReadingOrderComicsForm";
import SubmitComicModal from "../../library/routes/SubmitComicModal";

function ReadingOrderComics() {
  const { id } = useParams();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const readingOrderId = id;

  const { data, isLoading } = useQuery(
    ["readingOrder", readingOrderId],
    () => getAdminReadingOrder(readingOrderId),
    {
      refetchOnWindowFocus: false,
    }
  );
  const readingOrder = data?.data;

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Container maxW="container.xl">
      <Stack
        direction={["column", "column", "row", "row"]}
        mt="6"
        gap={3}
        pb="30px"
      >
        <Box maxW={["100%", "100%", "30%", "30%"]}>
          <Box bg="gray.700" borderRadius="lg">
            {/* Header */}
            <Box position="relative">
              <Button
                as={Link}
                to={`/my-orders/${readingOrder.id}/edit`}
                leftIcon={<EditIcon />}
                variant="solid"
                size="xs"
                position="absolute"
                bottom={0}
                right={0}
                zIndex={100}
                mr="3"
                mb="4"
              >
                Edit
              </Button>
              <ReadingOrderHeader
                readingOrder={readingOrder}
                progress={0}
                hideProgress
                showFranchise
              />
            </Box>
            {/* UpNext */}
            {!!readingOrder?.description && (
              <Box p="6">
                <Text pb="3" fontSize="sm">
                  {readingOrder?.description}
                </Text>
              </Box>
            )}
          </Box>

          <Box bg="gray.700" p="6" borderRadius="lg" mt="6">
            <Text fontWeight="bold" pb="3">
              Cannot find the comic you're looking for?
            </Text>
            <Button onClick={() => onOpen()}>Submit a missing comic</Button>
          </Box>
        </Box>

        {/* Reading order header */}
        <Box pb="300px" w={["100%", "100%", "70%", "70%"]}>
          <Box bg="gray.700" borderRadius="lg">
            <ReadingOrderComicsForm readingOrder={readingOrder} />
          </Box>
        </Box>
      </Stack>

      {/* Modal */}
      <SubmitComicModal isOpen={isOpen} onClose={onClose} />
    </Container>
  );
}

export default ReadingOrderComics;
